import $axios from "../../api/axios";

function createAccountApi({ params, callback }) {
  $axios
    .post("/api/register", params)
    .then(res => {
      console.log("params", params);
      callback(res);
    })
    .catch(err => {
      console.log(err);
    });

}

export default {
  createAccountApi
};



// WEBPACK FOOTER //
// ./src/api/register/register.js